













import { defineComponent, ref } from "@vue/composition-api";
import BaseSwitch from "@/components/BaseSwitch";

export default defineComponent({
  name: "AiResponseSetting",
  components: { BaseSwitch },
  props: {
    aiResponseEnabled: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const aiResponse = ref(props.aiResponseEnabled);

    const onInput = (newValue: boolean) => {
      aiResponse.value = newValue;
      emit("update:aiResponse", { aiResponseEnabled: aiResponse.value });
    };

    return {
      aiResponse,
      onInput,
    };
  },
});
